export const emailRegex = /\S[^\s@]*@\S+\.\S+/
